import { get } from 'lodash/fp';

export const getNotifications = get('notifications.notifications');
